import Base from './Base';
import MessageReassign from '../models/MessageReassign';

export default class MessagesReassign extends Base {
    get models() {
        const collection = this.data.map(item => new MessageReassign(item));
        collection.collection = this;

        return collection;
    }
}